import { useIsFocused } from 'expo-router'
import type Animated from 'react-native-reanimated'

import { useTimeout } from '@/src/general/hooks/useTimeout'

/** If the auto scroll is triggered too early, the list will not be able to scroll to the index */
const AUTO_SCROLL_DELAY = 200

export const useAutoScroll = (
  listRef: React.RefObject<Animated.FlatList | null>,
  nextPublicationIndex: number,
  isLoading: boolean,
) => {
  const isFocused = useIsFocused()
  const shouldAutoScroll = isFocused && !isLoading && nextPublicationIndex > 0

  useTimeout(
    () => {
      if (nextPublicationIndex > 0) {
        listRef.current?.scrollToIndex({ index: nextPublicationIndex - 1, animated: true, viewOffset: 0 })
        return
      }
    },
    shouldAutoScroll ? AUTO_SCROLL_DELAY : null,
  )
}
